const SOFT = 'soft';
const PAGINATION = 'pagination';

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    let selfClass = this
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this)

    const facetFiltersForm = document.querySelector("#FacetFiltersForm")
    const dataHasApplyButton = facetFiltersForm?.getAttribute('data-price-has-apply')
    if (dataHasApplyButton === 'true') {
      selfClass.querySelector('form').addEventListener('input', function (e) {
        if (!e.target.classList.contains('range-max') && !e.target.classList.contains('range-min')) {
          setTimeout(function () {
            FacetFiltersForm.onSubmitHandler(e);
          }, 500)
        }
      });
    } else {
      this.debouncedOnSubmit = window.debounce((event) => {
        FacetFiltersForm.onSubmitHandler(event);
      }, 500);
      const facetForm = this.querySelector('form');
      facetForm.addEventListener('input', function (e) {
        selfClass.debouncedOnSubmit(e)
      })
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    // const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    // if (countContainer) {
    //   countContainer.classList.add('loading');
    // }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        // FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderAsideShowContent()
      })
      .finally(() => {
        window.tpCountdownTimer.init();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    // FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderAsideShowContent()
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    document.dispatchEvent(new CustomEvent('bambe:collection-grid-updated'));
  }

  // static renderProductCount(html) {
  //   const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
  //   const container = document.getElementById('ProductCount');
  //   const containerDesktop = document.getElementById('ProductCountDesktop');
  //   container.innerHTML = count;
  //   container.classList.remove('loading');
  //   if (containerDesktop) {
  //     containerDesktop.innerHTML = count;
  //     containerDesktop.classList.remove('loading');
  //   }
  // }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetsWrapperParsedHTML = parsedHTML.querySelector('.facets-wrapper')

    if (facetsWrapperParsedHTML) {
      facetsWrapperParsedHTML.classList.add('show-facets-drawer')
    }

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');

    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);


    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    // FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderAsideShowContent() { // For drawer, horizontal
    const asideCurrent = document.querySelector('aside')
    if (asideCurrent) {
      const dataTypeAside = asideCurrent.getAttribute('data-type')

      if (dataTypeAside === 'horizontal' || dataTypeAside === 'drawer') {
        asideCurrent.classList.add('show-facets-drawer')
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    let nextParams = searchParams || '';
    if (window.BambeCollectionPin && typeof window.BambeCollectionPin.preserveParam === 'function') {
      nextParams = window.BambeCollectionPin.preserveParam(nextParams);
    }
    history.pushState({
      searchParams: nextParams
    }, '', `${window.location.pathname}${nextParams && '?'.concat(nextParams)}`);
  }

  static getSections() {
    return [{
      section: document.getElementById('product-grid').dataset.id,
    }]
  }

  static filterPriceRange(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  static createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  static onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  static onSubmitHandler(event) {

    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className === 'mobile-facets__checkbox') {
      const searchParams = FacetFiltersForm.createSearchParams(event.target.closest('form'))
      FacetFiltersForm.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(FacetFiltersForm.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(FacetFiltersForm.createSearchParams(form));
        }

      });

      // Handle check price min max equal min max start init
      const inuptPriceMin = document.querySelector(`input.field__input.range-min`)
      const inuptPriceMax = document.querySelector(`input.field__input.range-max`)

      let strFilterPriceInit = ''
      let indexFilterPrice
      forms.forEach(function (item, index) {

        if (item.indexOf('filter.v.price.gte') !== -1) {
          strFilterPriceInit = item
          indexFilterPrice = index
        }
      })

      const arrTmp = strFilterPriceInit.split('&')

      let minResult = null
      let maxResult = null
      arrTmp.forEach(function (item, index) {

        if (item.indexOf('filter.v.price.gte') !== -1) {
          minResult = item.replace('filter.v.price.gte=', '')
        }
        if (item.indexOf('filter.v.price.lte') !== -1) {
          maxResult = item.replace('filter.v.price.lte=', '')
        }
      })

      if (parseInt(inuptPriceMin?.getAttribute('min')) == parseInt(minResult) && parseInt(inuptPriceMax?.getAttribute('max')) == parseInt(maxResult)) {
        forms.splice(indexFilterPrice, 1)
        if (arrTmp.length > 2) {
          strFilterPriceInit = strFilterPriceInit.replace(`filter.v.price.gte=${minResult}&filter.v.price.lte=${maxResult}&`, '')
          if(strFilterPriceInit == `filter.v.availability=1&filter.v.price.gte=${minResult}&filter.v.price.lte=${maxResult}`){
            strFilterPriceInit = strFilterPriceInit.replace(`filter.v.availability=1&filter.v.price.gte=${minResult}&filter.v.price.lte=${maxResult}`, 'filter.v.availability=1')
          }
          if(strFilterPriceInit == `filter.v.availability=0&filter.v.price.gte=${minResult}&filter.v.price.lte=${maxResult}`){
            strFilterPriceInit = strFilterPriceInit.replace(`filter.v.availability=0&filter.v.price.gte=${minResult}&filter.v.price.lte=${maxResult}`, 'filter.v.availability=0')
          }
          forms.push(strFilterPriceInit)
        }
      }


      FacetFiltersForm.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  renderAside() {

  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);

customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

document.addEventListener('click', function (e) {
  const t = e.target;
  if (!t || !t.classList) return;
  if (
    !t.classList.contains('btn-price-filter') &&
    !t.classList.contains('btn-select-filter-sort') &&
    !t.classList.contains('item-sort') &&
    !t.closest('.btn-filter') &&
    !t.closest('.btn-close-filter') &&
    !t.closest('.facets-wrapper')
  ) {
    return;
  }

  if (t.classList.contains('btn-price-filter')) {
    FacetFiltersForm.onSubmitHandler(e);
  }

  if (t.classList.contains('btn-select-filter-sort')) {

    let facetFiltersField = t.closest('.facet-filters__field')
    // facetFiltersField.classList.toggle('show-select')
    if (facetFiltersField.classList.contains('show-select')) {
      facetFiltersField.classList.remove('show-select')
    } else {
      facetFiltersField.classList.add('show-select')
    }

  }

  if (t.classList.contains('item-sort')) {
    let facetFiltersField = t.closest('.facet-filters__field')
    let facetFiltersSort = facetFiltersField.querySelector(".facet-filters__sort")
    let type = SOFT
    let inputSortBy = facetFiltersSort.querySelector('input[name="sort_by"]')

    if (!inputSortBy) {
      type = PAGINATION
      inputSortBy = facetFiltersSort.querySelector('input[name="attributes[pagination]"]')
    }
    inputSortBy.value = t.getAttribute('value')

    if (type == PAGINATION) {
      let updateData = {
        attributes: {
          collection_products_per_page: parseInt(inputSortBy.value)
        }
      }
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateData)
      })
        .then((res) => res.json())
        .then((data) => {
          window.location.reload();
        })
        .catch(function (error) {
          console.error('Request failed', error)
        });
    }

    if (type == SOFT) {
      FacetFiltersForm.onSubmitHandler(e)
    }

    // reset active span select
    let isSelectedCurrent = facetFiltersSort.querySelector('.is-selected')
    isSelectedCurrent && isSelectedCurrent.classList.remove('is-selected')

    t.classList.add('is-selected')

    if (facetFiltersField) {
      let button = facetFiltersField.querySelector('button')
      if (button) {
        let dataValueCurrent = button.getAttribute('data-value')
        let dataValueNew = t.getAttribute('value')
        let textDataValueNew = t.textContent

        button.setAttribute("data-value", dataValueNew)
        button.querySelector('span').textContent = textDataValueNew

      }
    }
  }
}, { passive: true });

class PriceRange extends HTMLElement {
  constructor() {
    super();
    let selfClass = this
    // this.querySelectorAll('input')
    //   .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    // this.setMinAndMaxValues();

    this.rangeInput = this.querySelectorAll(".range-input input")
    this.infoMinPrice = this.querySelector(".min-price span")
    this.infoMaxPrice = this.querySelector('.max-price span')
    this.range = this.querySelector(".slider .progress")
    this.priceGap = 50

    this.rangeInput.forEach(input => {
      input.addEventListener("input", this.setRangePrice.bind(this));
    });
    this.initRangePirce()

    // Price range - Type bonus (Array)
    this.priceRangeItems = this.querySelectorAll(".price_range--item")
    this.fieldInputMin = this.querySelector('.field__input.range-min')
    this.fieldInputMax = this.querySelector('.field__input.range-max')

    if (this.priceRangeItems.length > 0) {
      // Init active price range
      selfClass.initActivePriceRange()

      this.priceRangeItems.forEach(function (item) {
        item.addEventListener('click', function (e) {
          selfClass.setPriceValue(item)
          FacetFiltersForm.onSubmitHandler(e)
        })
      })
    }
  }

  initRangePirce() {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)

    if (urlParams.has('filter.v.price.gte')) {
      const priceGte = urlParams.get('filter.v.price.gte')
      this.rangeInput[0] && this.rangeInput[0].setAttribute('value', priceGte || 0)
      if (this.range) {
        this.range.style.left = ((priceGte / this.rangeInput[0].max) * 100) + "%";
      }

      if (this.infoMinPrice) {
        this.infoMinPrice.textContent = priceGte
      }
    }
    if (urlParams.has('filter.v.price.lte')) {
      const priceLte = urlParams.get('filter.v.price.lte')
      this.rangeInput[1] && this.rangeInput[1].setAttribute('value', priceLte || this.maxPrice)
      if (this.range) {
        if (document.documentElement.classList.contains("rtl")) {
          this.range.style.left = 100 - (priceLte / this.rangeInput[1].max) * 100 + "%";
        } else {
          this.range.style.right = 100 - (priceLte / this.rangeInput[1].max) * 100 + "%";
        }

      }

      if (this.infoMaxPrice) {
        this.infoMaxPrice.textContent = priceLte
      }
    }
  }

  setRangePrice(e) {
    let minVal = parseInt(this.rangeInput[0].value),
      maxVal = parseInt(this.rangeInput[1].value);

    if ((maxVal - minVal) < 0) {
      if (e.target.className === "range-min") {
        this.rangeInput[0].value = maxVal - this.priceGap
      } else {
        this.rangeInput[1].value = minVal + this.priceGap;
      }
    } else {

      if (document.documentElement.classList.contains("rtl")) {
        this.range.style.right = ((minVal / this.rangeInput[0].max) * 100) + "%";
        this.range.style.left = 100 - (maxVal / this.rangeInput[1].max) * 100 + "%";

      } else {
        this.range.style.left = ((minVal / this.rangeInput[0].max) * 100) + "%";
        this.range.style.right = 100 - (maxVal / this.rangeInput[1].max) * 100 + "%";

      }

      this.infoMinPrice.textContent = this.rangeInput[0].value
      this.infoMaxPrice.textContent = this.rangeInput[1].value
    }
  }

  // For price range
  initActivePriceRange() {
    let selfClass = this

    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)

    if (urlParams.has('filter.v.price.gte')) {
      const priceGte = urlParams.get('filter.v.price.gte')
      selfClass.fieldInputMin.value = parseInt(priceGte)
    }
    if (urlParams.has('filter.v.price.lte')) {
      const priceLte = urlParams.get('filter.v.price.lte')
      selfClass.fieldInputMax.value = parseInt(priceLte)
    }

    selfClass.priceRangeItems.forEach(function (item) {
      const min = item.querySelector('.minp').getAttribute('data-min-price')
      const max = item.querySelector('.maxp').getAttribute('data-max-price')

      if (parseInt(min) == selfClass.fieldInputMin.value && parseInt(max) == selfClass.fieldInputMax.value) {
        item.classList.add('active-price-range')
      }
    })
  }

  setPriceValue(item) {
    let selfClass = this

    const min = item.querySelector('.minp').getAttribute('data-min-price')
    const max = item.querySelector('.maxp').getAttribute('data-max-price')

    selfClass.fieldInputMin.value = parseInt(min)
    selfClass.fieldInputMax.value = parseInt(max)

    // Active
    const wrapperPriceFilter = item.closest('.wrapper-price-filter')

    const activeCurrent = wrapperPriceFilter.querySelector('.active-price-range')
    if (activeCurrent) {
      activeCurrent.classList.remove('active-price-range')
    }

    item.classList.add('active-price-range')
  }

}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


